var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
var AvatarWithText = function (_a) {
    var avatar = _a.avatar, primaryText = _a.primaryText, secondaryText = _a.secondaryText, _b = _a.variant, variant = _b === void 0 ? 'circular' : _b;
    return (_jsxs(ListItem, { children: [_jsx(ListItemAvatar, { children: _jsx(Avatar, __assign({ variant: variant }, { children: avatar })) }), _jsx(ListItemText, { primary: primaryText, secondary: secondaryText })] }));
};
export default AvatarWithText;
